import React from 'react';
import GeneralEntryLogFigma from '../../../../Elements/GeneralEntryLog/GeneralEntryLogFigma';
import CommentsEntryLogDescription from '../../../../Elements/CommentsEntryLogDescription';
import AttachmentsComponent from '../../../../Elements/AttachmentsComponent';
import LogComponent from '../../../../Elements/LogComponent';
import TabbedPage from '../../../../Elements/TabbedPage';
import TaxComponent from '../../../../Elements/TaxComponent';
import TpClientInvoiceDetailsInfoTab from './TpClientInvoiceDetailsInfoTab';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import dateTimeHelper from '../../../../Helpers/datetimeHelper';
import TpClientInvoiceService from '../../../../Services/TpClientInvoiceService';
import TpClientInvoiceDetailsDetailsTab from './TpClientInvoiceDetailsDetailsTab';
import InvoicePdfPreviewComponent from '../../../../Elements/InvoicePdfPreviewComponent';
import TpClientInvoiceViewDescription from './TpClientInvoiceViewDescription';
import TpCreditMemoAdmin from '../../TpCreditMemo/TpCreditMemoAdmin';
import TpClientPaymentsAdmin from '../../../ThirdParty/TpClientPayment/TpClientPaymentsAdmin';

export default class TpClientInvoiceDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      fileName: '',
    };
  }

  urlParams = new URLSearchParams(window.location.search);
  tpClientInvoiceId = parseInt(this.urlParams.get('id') ?? '0');

  componentDidMount() {
    TpClientInvoiceService.GetSimpleById(this.tpClientInvoiceId)
      .then((res) => {
        if (res.error) {
          ErrorMessage.SetErrorMessage(res.error);
          return;
        }
        this.setState({
          fileName: `BARE_Invoice-${res.tpClientInvoiceId}-${res.billToClientName}-${dateTimeHelper.getFormattedDate(
            new Date(res.finalizedOnUtc ?? new Date()),
            '-'
          )}`,
        });
      })
      .catch((error) => ErrorMessage.SetErrorMessage('TPCID44', error));
  }

  static getMenuText() {
    const id = new URLSearchParams(window.location.search).get('id');
    return `Third-Party Client Invoice ${id ? '- ' + id : 'Details'}`;
  }

  tabs = () => [
    {
      label: 'Information',
      id: 'info',
      icon: 'fa-solid fa-info',
      component: <TpClientInvoiceDetailsInfoTab tpClientInvoiceId={this.tpClientInvoiceId} />,
    },
    {
      label: 'Invoice Details',
      id: 'details',
      icon: 'fa-solid fa-file-invoice',
      component: <TpClientInvoiceDetailsDetailsTab tpClientInvoiceId={this.tpClientInvoiceId} />,
    },
    {
      label: 'Invoice View',
      id: 'view',
      icon: 'fa-solid fa-eye',
      component: (
        <InvoicePdfPreviewComponent
          id={this.tpClientInvoiceId}
          invoiceDescription={TpClientInvoiceViewDescription}
          excelWordRoleKey='tpclientinvoices_view'
          attachRoleKey='tpclientinvoices_edit'
          downloadFileName={this.state.fileName}
          hideSearchStrip={true}
        />
      ),
    },
    {
      label: 'Payments Applied',
      id: 'paymentsapplied',
      icon: 'fa-solid fa-check',
      component: <TpClientPaymentsAdmin tpClientInvoiceId={this.tpClientInvoiceId} />,
    },
    {
      label: 'Credit Memos',
      id: 'creditmemos',
      icon: 'fa-solid fa-credit-card',
      roleKey: 'tpcreditmemos_view',
      component: <TpCreditMemoAdmin tpClientInvoiceId={this.tpClientInvoiceId} />,
    },
    {
      label: 'Taxes',
      id: 'taxes',
      icon: 'fa-solid fa-percent',
      component: (
        <TaxComponent
          entityTypeId={500}
          entityId={this.tpClientInvoiceId ? parseInt(this.tpClientInvoiceId) : null}
          isActiveSlide={false}
          showEdit={false}
          showAddNewTaxLink={false}
          showRemove={false}
        />
      ),
    },
    {
      label: 'Comments',
      id: 'comments',
      icon: 'fa-solid fa-comment',
      component: (
        <GeneralEntryLogFigma
          description={CommentsEntryLogDescription}
          context={{ entityTypeId: 500, entityId: this.tpClientInvoiceId }}
        />
      ),
    },
    {
      label: 'Attachments',
      id: 'attachments',
      icon: 'fa-solid fa-paperclip',
      component: (
        <AttachmentsComponent
          entityTypeId={500}
          entityId={this.tpClientInvoiceId}
          enableAddNew={true}
        />
      ),
    },
    {
      label: 'Logs',
      id: 'logs',
      icon: 'fa-solid fa-stream',
      component: (
        <LogComponent
          entityType='TpClientInvoice'
          entityId={this.tpClientInvoiceId}
        />
      ),
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <TabbedPage tabs={this.tabs()} />
      </div>
    );
  }
}
